module.exports = __webpack_public_path__ + "assets/img/37_1632.c42c0d81.jpg";